import { Expose } from "class-transformer";
import { Model } from "./model";

export class DeviceModel extends Model {
    @Expose() version: string;
    @Expose() type: string;
    @Expose() language: string;
    @Expose() notificationToken: string;
    @Expose() osVersion: string;
    @Expose() model: string;
    @Expose() sinchAppKey: string;
    @Expose() deviceUUID: string;
    @Expose() voipToken: string;
    @Expose() apiVersion: string;
    @Expose() isProduction: boolean;
    @Expose() simCardISOCountry: string;
    @Expose() deviceName: string;
    @Expose() modelId: string;
    @Expose() adjustAdsId: string;
    @Expose() ipAddress: string;
    @Expose() showRateAppMessage: boolean;
    @Expose() showSurvey: boolean;
    @Expose() surveyType: string;
    @Expose() isHuawei: boolean;
}